import { Box, Divider, Typography } from "@mui/joy";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { BadgePlus } from "lucide-react";

import { Button } from "../../../../../shared";

interface ActionProps {
    onCreate: () => void;
    creating?: boolean;
}

export default function Action({ onCreate, creating = false }: ActionProps) {
    const navigate = useNavigate();
    const {
        formState: { isValid },
    } = useFormContext();

    return (
        <Box mt={2}>
            <Divider sx={{ mb: 1 }} />
            <Typography level="body-sm" sx={{ mb: 1 }}>
                Create a new project with the details above.
            </Typography>
            <Box display="flex" gap={2} flexWrap="wrap">
                <Button
                    type="button"
                    variant="outlined"
                    color="neutral"
                    disabled={creating}
                    onClick={() => navigate("/project/list")}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    disabled={!isValid || creating}
                    loading={creating}
                    loadingPosition="end"
                    startDecorator={!creating ? <BadgePlus size={18} /> : undefined}
                    variant="solid"
                    color="primary"
                    onClick={onCreate}
                >
                    {creating ? "Creating project…" : "Create Quick Project"}
                </Button>
            </Box>
        </Box>
    );
}
